import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

Vue.use(Router);

const router = new Router({
    mode: 'hash',
    routes: [{
        path: '/',
        component: () =>
            import("@/views/main/login.vue"),
        meta: {
            title: '登录'
        },
    },
    {
        path: '/gradeTemperature',
        component: () =>
            import("@/views/main/grade.vue"),
        meta: {
            title: '学生考勤'
        },
    },
    {
        path: '/gradeDormTemperature',
        component: () =>
            import("@/views/main/gradeDorm.vue"),
        meta: {
            title: '住宿生考勤'
        },
    },
    {
        path: '/classTemperature',
        component: () =>
            import("@/views/main/class.vue"),
        meta: {
            title: '学生考勤'
        },
    },
    {
        path: '/classDormTemperature',
        component: () =>
            import("@/views/main/classDorm.vue"),
        meta: {
            title: '住宿生考勤'
        },
    },
    {
        path: '/gradeTemperature',
        component: () =>
            import("@/views/main/grade.vue"),
        meta: {
            title: '学生考勤'
        },
    },
    {
        path: '/abnormalTemperature',
        component: () =>
            import("@/views/main/abnormal.vue"),
        meta: {
            title: '异常考勤'
        },
    },
    {
        path: '/teacherTemperature',
        component: () =>
            import("@/views/main/teacher.vue"),
        meta: {
            title: '教职工考勤'
        },
    },
    {
        path: '/my',
        component: () =>
            import("@/views/main/my.vue"),
        meta: {
            title: '我的考勤'
        },
    },
    {
        path: '/myCenter',
        component: () =>
            import("@/views/main/center.vue"),
        meta: {
            title: '我的'
        },
    },
    {
        path: '/student',
        component: () =>
            import("@/views/main/student.vue"),
        meta: {
            title: '考勤数据'
        },
    },
    {
        path: '/studentDetail',
        component: () =>
            import("@/views/main/studentDetail.vue"),
        meta: {
            title: '考勤数据详情'
        },
    },
    {
        path: "*",
        component: () =>
            import("@/components/NotFound")
    }
    ]
});

export default router;